import React from 'react';
import moment from 'moment';

export interface PreloadRecord {
  date?: string | Date;
  dateOfIncident?: string | Date;
  type: string;
  policyViolated?: string;
  policyViolations?: { name?: string }[];
}

interface PreloadRecordsTableProps {
  title: string;
  records: PreloadRecord[];
}

const PreloadRecordsTable = ({ title, records }: PreloadRecordsTableProps) => {
  const getDate = (record: PreloadRecord) => record.date ?? record.dateOfIncident ?? '';
  const getPolicy = (record: PreloadRecord) =>
    record.policyViolated ??
    record.policyViolations
      ?.map((p) => p?.name)
      .filter(Boolean)
      .join(', ') ??
    '';

  return (
    <div className="mb-4">
      <h5 className="text-primary mb-3">{title}</h5>
      <div
        style={{
          width: '100%',
          border: '1px solid #dee2e6',
          borderRadius: '4px',
          overflow: 'hidden',
          maxHeight: records.length > 5 ? '240px' : 'auto',
          overflowY: records.length > 5 ? 'auto' : 'hidden',
        }}
      >
        <table style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
          <thead style={{ position: 'sticky', top: 0, backgroundColor: '#f8f9fa', zIndex: 1 }}>
            <tr>
              <th
                style={{
                  width: '33%',
                  padding: '8px 12px',
                  textAlign: 'left',
                  borderBottom: '2px solid #dee2e6',
                  fontWeight: 600,
                  fontSize: '0.9rem',
                }}
              >
                Date
              </th>
              <th
                style={{
                  width: '33%',
                  padding: '8px 12px',
                  textAlign: 'left',
                  borderBottom: '2px solid #dee2e6',
                  fontWeight: 600,
                  fontSize: '0.9rem',
                }}
              >
                Type
              </th>
              <th
                style={{
                  width: '34%',
                  padding: '8px 12px',
                  textAlign: 'left',
                  borderBottom: '2px solid #dee2e6',
                  fontWeight: 600,
                  fontSize: '0.9rem',
                }}
              >
                Policy Violated
              </th>
            </tr>
          </thead>
          <tbody>
            {records.length === 0 ? (
              <tr>
                <td
                  colSpan={3}
                  style={{
                    padding: '16px',
                    textAlign: 'center',
                    color: '#6c757d',
                    fontSize: '0.9rem',
                  }}
                >
                  No records found
                </td>
              </tr>
            ) : (
              records.map((record: PreloadRecord, index: number) => (
                <tr key={index} style={{ borderBottom: '1px solid #dee2e6' }}>
                  <td style={{ padding: '8px 12px', fontSize: '0.9rem', verticalAlign: 'middle' }}>
                    {getDate(record) ? moment.utc(getDate(record)).format('MM/DD/YYYY') : '-'}
                  </td>
                  <td style={{ padding: '8px 12px', fontSize: '0.9rem', verticalAlign: 'middle' }}>{record.type}</td>
                  <td style={{ padding: '8px 12px', fontSize: '0.9rem', verticalAlign: 'middle' }}>
                    {getPolicy(record)}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PreloadRecordsTable;
